<template>
  <b-table :data="data" :loading="isLoading" paginated backend-pagination :total="total" :per-page="perPage"
    @page-change="onPageChange" aria-next-label="Próxima Página" aria-previous-label="Página Anterior"
    aria-page-label="Página" aria-current-label="Página Atual">
    <template slot-scope="props">
      <b-table-column label="#" numeric>{{ props.row.id }}</b-table-column>

      <b-table-column label="Data e Hora">
        {{ props.row.datetime | date('DD/MM/YYYY [às] HH:mm') }}
      </b-table-column>

      <b-table-column label="Arquivo">{{ props.row.file_name }}</b-table-column>

      <b-table-column label="Tipo de Relatório">{{ props.row.type }}</b-table-column>

      <b-table-column label="Status">{{ props.row.status }}</b-table-column>

      <b-table-column label="Opções">
        <button @click="onClickDownload(props.row.id)" v-app-button.icon-only color="danger"
          v-tooltip.bottom="'Download'">
          <b-icon size="is-small" icon="magnify"></b-icon>
        </button>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import ReportService from '@/services/report.service';
import { ProcessingStatusLabel } from '@/enums/ProcessingStatusEnum';
/* import { ReportTypeLabel } from '@/enums/ReportTypeEnum'; */

export default {
  name: 'reports-table',
  data: () => {
    return {
      data: [],
      total: 0,
      isLoading: true,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      ReportService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;
          this.data = data.map((status) => ({
            ...status,
            typeLabel: ProcessingStatusLabel.get(status),
          }))
          ;
          this.total = total;
        })
        .catch(() => this.toastify('Erro ao carregar Relatórios.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    onClickDownload(id) {
      this.$buefy.dialog.confirm({
        title: 'Baixar Arquivo',
        message:
          'Tem certeza que deseja solicitar o download desse Relatório ?.',
        cancelText: 'Cancelar',
        confirmText: 'Baixar Relatorio',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.DownloadReport(id),
      });
    },
    DownloadReport(id) {
      this.isLoading = true;

      ReportService.download(id)
        .then((response) => {
          this.toastify(
            'Link gerado com sucesso, link estará disponível por uma hora'
          );
          window.open(response.data, '_blank')
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao gerar Link.',
            'error'
          );
        })
        .finally(() => (this.isLoading = false));
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
